import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'

const itemsPerPage = 6;
const Projects = ({openModal,setOpenModal}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [toggle, setToggle] = useState('all');
  const getPageRange = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return { startIndex, endIndex };
  };

  const handleToggleChange = (newToggle) => {
    setToggle(newToggle);
    projects.forEach(item => {
      console.log(item.title,item.category.indexOf(newToggle) != -1);
      
    });
    setCurrentPage(1); // Call setCurrentPage with 1 when toggle changes
};

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const filteredProjects = toggle === 'all' ? projects : projects.filter((item) => item.category.includes(toggle) );
  

  return (
    <Container id="projects" >
      <Wrapper>
        <Title>Projects</Title>
        <Desc style={{margin: "0 6px"}}>
        My projects, ranging from web and Android apps to digital artwork. Below are some of my projects and works.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => handleToggleChange('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => handleToggleChange('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'web app' ?
            <ToggleButton active value="web app" onClick={() => handleToggleChange('web app')}>Websites</ToggleButton>
            :
            <ToggleButton value="web app" onClick={() => handleToggleChange('web app')}>Websites</ToggleButton>
          }
          <Divider />
          {toggle === 'android app' ?
            <ToggleButton active value="android app" onClick={() => handleToggleChange('android app')}>Android Apps</ToggleButton>
            :
            <ToggleButton value="android app" onClick={() => handleToggleChange('android app')}>Android Apps</ToggleButton>
          }
          <Divider />
          {toggle === 'digital artwork' ?
            <ToggleButton active value="digital artwork" onClick={() => handleToggleChange('digital artwork')}>Digital artwork</ToggleButton>
            :
            <ToggleButton value="digital artwork" onClick={() => handleToggleChange('digital artwork')}>Digital Artwork</ToggleButton>
          }
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
          .slice(getPageRange().startIndex, getPageRange().endIndex)
            .map((project,index) => (
              <ProjectCard key={index} project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
          {projects
            .filter((item) => item.category.includes(toggle))
            .slice(getPageRange().startIndex, getPageRange().endIndex)
            .map((project,index) => (
              <ProjectCard key={index} project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
        </CardContainer>
        <div className='pagination'>
        {/* Previous page button */}
        <button style={{borderRadius:'12px 0 0 12px'}} className="pagination-btn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          Prev
        </button>
        {/* Next page button */}
        <button style={{borderRadius:'0 12px 12px 0'}} className="pagination-btn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage * itemsPerPage >= filteredProjects.length}>
          Next
        </button>
      </div>
      </Wrapper>
    </Container>
  )
}

export default Projects